import { gql } from '@apollo/client';

export const UPSERT_ACTIVITY = gql`
  mutation upsertActivity($input: UpsertActivityInput!) {
    activities: upsertActivity(input: $input) {
      id
      activityTargets {
        id
        endDate
        groupingType
        numberOfSessions
        expectedNumberOfAttendees
        plannedDuration
        startDate
        cohort {
          id
          name
        }
        frequency {
          id
          name
        }
        frequencyType {
          id
          name
        }
        institution {
          id
          name
        }
      }
      audienceSize {
        id
        name
      }
      audienceType {
        id
        name
      }
      cohorts {
        id
        name
      }
      description
      groupingType
      guestsAreTracked
      sessionBasedAttendees
      caseManagement
      requiresReview
      flagReview
      inputTypes {
        id
        name
        quantity {
          quantity
        }
      }
      institutions {
        id
        name
      }
      interfaceType {
        id
        name
      }
      multiDay
      name
      numberOfDays
      weeklyTracking
      weekStartDay
      numberOfDaysPerWeek
      sunday
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      historicalData
      stakeholderTypes {
        id
        name
      }
      substitutesAreAllowed
      targetAudiences {
        id
        name
      }
      targetGroup {
        id
        name
      }
      totalNumberOfSessions
      trackingLevel
      type {
        id
        name
      }
      programme {
        id
        name
      }
    }
  }
`;
